import React from 'react'

import { Form, Col, Button } from '_zari/core'

import { TiposDocumentoIdentificacionConstant, TiposDocumentoSunatConstant, MonedasConstant } from 'constants/index'

import { HistorialVentasModal, NuevoClienteAkdemicModal } from 'sharedComponents/modals'
import { Select2Akdemic } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { IdGen } from 'utils'

import * as SocioCrud from 'services/socio.service'


const SocioFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)
  const [mostrarHistorialModal, setMostrarHistorialModal] = React.useState(false)
  const [__keyReadOnly, setKeyReadOnly] = React.useState(IdGen.newId())


  const editarDataRef = React.useRef()

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values.codigoAkdemic = pickedMember.codigoAkdemic
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      if (data.tipoDocumento === TiposDocumentoIdentificacionConstant.RUC) {
        values.tipoDocumento = TiposDocumentoSunatConstant.FACTURA
      }

      setValues(values)
    })
  }

  const onCreate = (socioCreado, closeModal) => {
    values._idSocio = socioCreado._id
    values.nombreSocio = socioCreado.razonSocial
    values.codigoSocio = socioCreado.codigo
    values.documentoSocio = socioCreado.numeroDocumento
    values.tipoDocumentoSocio = socioCreado.tipoDocumento
    values.codigoAkdemic = socioCreado.codigoAkdemic

    if (socioCreado.tipoDocumento === TiposDocumentoIdentificacionConstant.RUC) {
      values.tipoDocumento = TiposDocumentoSunatConstant.FACTURA
    }

    setValues(values)
    closeModal()
  }

  const clickClear = () => {
    values._idSocio = ''
    values._idDireccionSocio = ''
    values.nombreSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.tipoDocumentoSocio = ''
    values.moneda = MonedasConstant.SOLES
    values._idAnticipo = ''
    values.montoAnticipo = 0

    values.tipoDocumento = TiposDocumentoSunatConstant.BOLETA

    setValues(values)
  }

  const onUpdate = () => {
    clickClear()

    setMostrarEditarModal(false)
    setKeyReadOnly(IdGen.newId())
    editarDataRef.current = {}
  }

  const clickEditar = React.useCallback(() => {
    SocioCrud.obtenerxIdAsEdicionFromVentas(values._idSocio).then(({ data }) => {
      editarDataRef.current = data
      setMostrarEditarModal(true)
    })
  }, [values._idSocio])

  return (
    <>
      <Form.Group>
        <Form.Label text='CLIENTE' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <ClearInputGroup
              key={__keyReadOnly}
              id='input-codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
              append={
                <>
                  <Button outline color='warning' onClick={clickEditar}>
                    S
                  </Button>
                  <Button outline onClick={() => setMostrarHistorialModal(true)}>
                    H
                  </Button>
                </>
              }
            />
          ) : (
            <>
              <Select2Akdemic
                disabled={fIsSubmitting}
                id='codigoRucSelect'
                onChange={onChangeSocioHandler}
                showNewButton
                showCheckboxAlias
                onCreate={onCreate}
              />
            </>
          )}
          {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
        </Col>
      </Form.Group>
      {mostrarEditarModal && (
        <NuevoClienteAkdemicModal
          show={mostrarEditarModal}
          handleClose={() => setMostrarEditarModal(false)}
          edicionData={editarDataRef.current}
          onUpdate={onUpdate}
        />
      )}
      {mostrarHistorialModal && (
        <HistorialVentasModal
          handleClose={() => setMostrarHistorialModal(false)}
          show={mostrarHistorialModal}
          idSocio={values._idSocio}
        />
      )}
    </>
  )
}

export default React.memo(SocioFormGroup)
